import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { DetectDevicesService } from '@fi-shared/fi-shared-services';
import { SessionService } from '@fi-app/utilities/fi-services/session.service';
import { SystemNotificationsService } from '@fi-app/system-notifications/system-notifications.service';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { IMenuItem } from '@fi-app/core/core.service';
import { takeUntil } from 'rxjs/operators';
import { FiStateChangeService } from '@fi-shared/fi-state-proxy/fi-state-change.service';
import { Subject } from 'rxjs';

@Component({
    selector: 'fi-main-menu-item',
    templateUrl: './menu-item.component.html',
    styleUrls: ['./menu-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-main-menu-item' },
    standalone: false,
})
export class MenuItemComponent implements OnInit, OnDestroy {
    @Input() menuItem: IMenuItem;
    Session: any;

    constructor(
        private sessionService: SessionService,
        private detectDevices: DetectDevicesService,
        private cdr: ChangeDetectorRef,
        private systemNotificationsService: SystemNotificationsService,
        private stateService: FiStateService,
        private stateChangeService: FiStateChangeService,
    ) {}

    ngOnInit() {
        this.Session = this.sessionService.getSession();

        this.stateChangeService.onFinish$.pipe(takeUntil(this.ngOnDestroy$)).subscribe(() => {
            setTimeout(() => {
                this.cdr.markForCheck();
            });
        });
    }

    protected ngOnDestroy$ = new Subject<void>();
    ngOnDestroy(): void {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }

    GetMenuItemUrl(menuItem: IMenuItem): string {
        if (menuItem.getUrl) return menuItem.getUrl();

        return this.stateService.href(menuItem.State, menuItem.StateParams, { inherit: false }) || '/';
    }

    OnMenuItemClick(menuItem: IMenuItem, $event) {
        if (menuItem.State) {
            $event.preventDefault();
            this.stateService.go(menuItem.State, menuItem.StateParams, { inherit: false, reload: true });
        } else if (menuItem.onClick) {
            menuItem.onClick(menuItem, $event);
        }
        this.sessionService.toggleDashboard(false);
        if (this.detectDevices.isMobilePhone()) this.systemNotificationsService.close();
    }

    OnCountClick(menuItem: IMenuItem, $event: MouseEvent) {
        $event.preventDefault();
        this.stateService.go(menuItem.CountState, menuItem.CountParams, { inherit: false, reload: true });
    }

    IsMenuItemSelected(menuItem: IMenuItem) {
        if (this.stateService.current.name.indexOf(menuItem.State) === 0) return true;

        if (menuItem.RootStates) {
            const currentState = menuItem.RootStates.find(
                (stateName) => this.stateService.current.name.indexOf(stateName + '.') === 0,
            );
            if (currentState) return true;
        }
        return false;
    }

    GetCountUrl(menuItem): string {
        return this.stateService.href(menuItem.CountState, menuItem.CountParams, { inherit: false, reload: true });
    }
}
